export const companyName = 'Divine Technovations Pvt Ltd';

export const address = {
  line1: 'Survey Number 62/1, Old 168/1p2',
  line2: 'Near Radium Creation and Mutual Industries',
  line3: 'Village Tumb-396150, Taluka Umbergaon, Dist Valsad',
  full: 'Divine Technovations Pvt Ltd, Survey Number 62/1, Old 168/1p2, Near Radium Creation and Mutual Industries, Village Tumb-396150, Taluka Umbergaon, Dist Valsad',
};

export const gst = '24AAGCD7252G1ZR';

export const contacts = [
  {
    name: 'Vimal Dave',
    phone: '9322604454',
    phoneDisplay: '+91 93226 04454',
    email: 'vimal@modurax.com',
  },
  {
    name: 'Bhushan Dave',
    phone: '9833978350',
    phoneDisplay: '+91 98339 78350',
    email: 'bhushan@modurax.com',
  },
];

export const primaryContact = contacts[1];

export const PHONE_E164 = `+91${primaryContact.phone}`;
export const PHONE_DISPLAY = primaryContact.phoneDisplay;
export const EMAIL = primaryContact.email;

export const whatsappUrl = (text = '') => {
  const base = `https://wa.me/91${primaryContact.phone}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const MAP_EMBED_SRC =
  'https://maps.google.com/maps?q=Divine+Technovations+Umbergaon+Tumb+Valsad&hl=en&z=14&output=embed';
